<app-list-selector [parentFormGroup]="parentFormGroup" [appList]="sectionConfig.filter.appIds"
    [sectionConfig]="sectionConfig" [caption]="'Add App to Section'" [controlName]="'appIds'"></app-list-selector>
